import { reportManagerIsDateRangeByDays } from '@sigma-frontend-libs/commons'

import { components, getLocaleDateString } from '@/utils'

import { getDateRangeByDaysReplacements, serviceNameViaPoint } from '@/components/services/report-manager/queue/utils'

import render from './render'

export default {
  name: 'DateRange',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },

    /**
     * Тип отчёта.
     * Для типов с периодом по дням включает подсказку с перечнем дней, вошедших в отчёт.
     *
     * @type {string}
     * @default undefined
     */
    type: {
      type: String,
      default: undefined
    }
  },

  computed: {
    rows() {
      const result = []
      const order = [ 'gte', 'lt' ]
      for (const key of order) {
        if (key in this.value) {
          const item = []
          switch (key) {
            case 'gte': {
              item.push(this.getTranslate('misc.date.from'))
              break
            }
            case 'lt': {
              item.push(this.getTranslate('misc.date.by'))
              break
            }
          }

          item.push(getLocaleDateString(this.value[key]))

          result.push(item.join(' '))
        }
      }

      return result
    },

    /**
     * Подсказка с перечнем дней, вошедших в отчёт с периодом по дням.
     * Последний день периода - день перед границей `lt`, которая в отчёт не входит.
     *
     * @returns {string | undefined}
     */
    tooltip() {
      if (!reportManagerIsDateRangeByDays(this.type) || !this.value.gte || !this.value.lt) {
        return
      }

      return this.getTranslate(`${serviceNameViaPoint}.tooltips.dateRangeByDays`, getDateRangeByDaysReplacements(this.value))
    },

    /**
     * Директивы корневого элемента: подсказка с перечнем дней при её наличии.
     *
     * @returns {Array<{ name: string, options: { value: string } }>}
     */
    $_directives() {
      const result = []
      if (this.tooltip) {
        result.push({
          name: components.tooltip,
          options: { value: this.tooltip }
        })
      }

      return result
    }
  },

  render
}
